import React from "react";
import image1 from '../../../Assets/resource/EV.png'
import image from '../../../Assets/resource/MobileApp.png'
import appstore from '../../../Assets/shared/app_link_apple.svg';
import playstore from '../../../Assets/shared/app_link_playstore.svg';

export default function EVPromoSection() {
    return (

        <div className="blade-margin-top-sm containers-min mx-auto px-4 py-12">
            <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
                <h3 className="text-center font-gilroy">
                    Every EV loves VerdeMobility. Yours will too
                </h3>
            </div>

            {/* Two-column layout */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Card 1 */}
                <div className="rounded-xl overflow-hidden shadow-md relative">
                    <img
                        src={image1}
                        alt="EV Charger"
                        className="w-full h-full object-cover"
                    />
                    <p className="p-4 text-white absolute text-center inset-x-0 top-4 font-poppins">
                        No matter your EV, We have got you covered
                    </p>
                </div>

                {/* Card 2 */}
                <div className="rounded-xl overflow-hidden shadow-md relative">
                    <img
                        src={image}
                        alt="App"
                        className="w-full h-full object-cover"
                    />
                    <div className="p-5 pb-10 absolute inset-x-0 top-4 flex flex-col justify-between h-full">
                        <p className="text-white text-center font-poppins">
                            Monitor and manage your charger with the EV Life app
                        </p>
                        {/* App store buttons */}
                        <div className="flex gap-3">
                            <a
                                href="https://apps.apple.com/in/app/verdemobility/id1622189313"
                                className="max-w-[120px] md:max-w-[200px] md:min-w-[200px]"
                                rel="noreferrer"
                                target="_blank"
                            >
                                <span className="sr-only font-poppins">Download IOS app</span>

                                <img
                                    loading="lazy"
                                    src={appstore}
                                    className="py-2 "
                                    alt="app strore link"
                                />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.verdemobility.ev.charger"
                                className="max-w-[120px] md:max-w-[200px] md:min-w-[200px]"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <span className="sr-only font-poppins">Download Android app</span>
                                <img
                                    loading="lazy"
                                    src={playstore}
                                    className="py-2"
                                    alt="play strore link"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
